import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaHome, FaShoppingCart, FaUser } from "react-icons/fa";
import { MdCategory, MdStore } from "react-icons/md";
import { HiUserAdd } from "react-icons/hi";
import "../../../assets/css/general/bottomnavigation/BottomNavigation.css";
import AppContext from "../../../contexts/AppContext";

const BottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activePage, setActivePage] = useState("/");
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const { unreadCounts, clearUnread } = useContext(AppContext);

  // Check authentication status
  useEffect(() => {
    const checkAuth = () => {
      const authToken = localStorage.getItem("customerAuthToken");
      setIsAuthenticated(!!authToken);
    };

    checkAuth();
    // Update active page based on current location
    setActivePage(location.pathname);

    // Listen for storage changes (when user logs in/out)
    const handleStorageChange = () => {
      checkAuth();
    };

    window.addEventListener("storage", handleStorageChange);

    // Custom event listener for same-tab login/logout
    window.addEventListener("authChange", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("authChange", handleStorageChange);
    };
  }, [location.pathname]);

  // Navigation handler with active state
  const handleNavigation = (path) => {
    setActivePage(path);
    navigate(path);
  };

  // Handle register/profile click
  const handleAuthClick = () => {
    if (isAuthenticated) {
      // User logged in hai, profile/account page par le jao
      handleNavigation("/account");
    } else {
      // User logged in nahi hai, auth page par le jao
      handleNavigation("/profile");
    }
  };

  return (
    <div className="mobile-bottom-nav">
      <div className="bottom-nav-container">
        {/* Home */}
        <div
          className={`nav-item ${activePage === "/" ? "active" : ""}`}
          onClick={() => handleNavigation("/")}
        >
          <FaHome className="nav-icon" />
          <span className="nav-label">Home</span>
        </div>

        {/* Categories */}
        <div
          className={`nav-item ${activePage === "/cpPage" ? "active" : ""}`}
          onClick={() => handleNavigation("/categories")}
        >
          <MdCategory className="nav-icon" />
          <span className="nav-label">Categories</span>
        </div>

        {/* Shops */}
        <div
          className={`nav-item ${activePage === "/shops" ? "active" : ""}`}
          onClick={() => handleNavigation("/shops")}
        >
          <MdStore className="nav-icon" />
          <span className="nav-label">Shop</span>
        </div>

        {/* Cart */}
        <div
          className={`nav-item ${activePage === "/cart" ? "active" : ""}`}
          onClick={() => {
            handleNavigation("/cart");
            clearUnread("cart");
          }}
        >
          <FaShoppingCart className="nav-icon" />
          <span className="nav-label">Cart</span>
          {unreadCounts.cart > 0 && (
            <span className="cart-badge">{unreadCounts.cart}</span>
          )}
        </div>

        {/* Profile - Always shows Profile */}
        <div
          className={`nav-item ${activePage === "/profile" || activePage === "/account" || activePage === "/auth" ? "active" : ""}`}
          onClick={handleAuthClick}
        >
          <FaUser className="nav-icon" />
          <span className="nav-label">Account</span>
        </div>
      </div>
    </div>
  );
};

export default BottomNavigation;